import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'

//修改router的跳转事件，取消报错提示。
const originalReplace = Router.prototype.replace
const originalPush = Router.prototype.push
Router.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => err)
}
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
	mode: 'history', // require service support
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path:"/",
			component: () => import('@/views/index'),
			name:"",
			hidden:true,
		},
		{
			path: '/404',
			// component: Layout,
			component: () => import('@/views/404'),
			name: '404',
			hidden: true,
			// children: [{
			// 	path: '/404',
			// 	name: '404',
			// }]
		},
		{
			path: '/:shopid([0-9a-zA-Z]{5,10})',
			component: Layout,
			name:'home',
			children: [
				{
					path: '',
					name: 'home',
					component: () => import('@/views/home/index'),
					meta: { title: '首页',isShowTabbar: true, notBack:true}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/product',
					name: 'product',
					component: () => import('@/views/product/index'),
					meta: { title: '商品',isShowTabbar: true, notBack: true}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/product/:product_id([0-9a-zA-Z]{13,13})',
					name: 'product_info',
					component: () => import('@/views/product/info'),
					meta: { title: '商品详情'}
				},
				/*{
					path: '/:shopid([0-9a-zA-Z]{5,10})/order/create_:product_id([0-9a-zA-Z]{13,13})',
					name: 'createOrder',
					component: () => import('@/views/order/create'),
					meta: { title: '创建订单'}
				},*/
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/order/pay',
					name: 'payOrder',
					component: () => import('@/views/order/pay'),
					meta: { title: '支付订单'}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/vip_code/:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCode',
					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值', data_type: "aliyun",}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/vip_code/status_:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCodeStatus',

					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值状态', data_type: "aliyun",}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/me',
					name: 'me',
					component: () => import('@/views/me/index'),
					meta: { title: '订单',isShowTabbar: true, notBack: true}
				},



				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/alivip_code/:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCode',

					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值', data_type: "aliyun",}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/alivip_code/status_:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCodeStatus',
					data_type: "aliyun",
					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值状态', data_type: "aliyun",}
				},

				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/quarkvip_code/:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCode',

					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值', data_type: "quark",}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/quarkvip_code/status_:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCodeStatus',
					data_type: "quark",
					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值状态', data_type: "quark",}
				},

				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/ucvip_code/:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCode',

					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值', data_type: "ucpan",}
				},
				{
					path: '/:shopid([0-9a-zA-Z]{5,10})/ucvip_code/status_:vip_code([0-9a-zA-Z]{32,32})',
					name: 'payVipCodeStatus',
					component: () => import('@/views/order/payvipcode'),
					meta: { title: '充值状态', data_type: "ucpan",}
				},

			]
		},
		{ path: '*', redirect: '/404', hidden: true }
	]
})
router.beforeEach((to, form, next) => {
	if (to.meta.title) { // 判断是否有标题
			document.title = to.meta.title;
	}
	next();
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js